import { render, staticRenderFns } from "./ModalDadosUltimaAlteracaoUsuario.vue?vue&type=template&id=b7f491f6"
import script from "./ModalDadosUltimaAlteracaoUsuario.vue?vue&type=script&lang=js"
export * from "./ModalDadosUltimaAlteracaoUsuario.vue?vue&type=script&lang=js"
import style0 from "./ModalDadosUltimaAlteracaoUsuario.vue?vue&type=style&index=0&id=b7f491f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports